/**
 * @file Modal.js
 * @description Componente visual para alertas e confirmações.
 */
import React from "react";
import { X, AlertTriangle, CheckCircle, Info } from "lucide-react";

const icons = {
  success: <CheckCircle className="h-6 w-6 text-green-400" />,
  error: <AlertTriangle className="h-6 w-6 text-red-400" />,
  info: <Info className="h-6 w-6 text-blue-400" />,
  confirm: <AlertTriangle className="h-6 w-6 text-yellow-400" />,
};

const Modal = ({
  isOpen,
  onClose,
  title,
  message,
  type = "info",
  onConfirm,
}) => {
  if (!isOpen) {
    return null;
  }

  const isConfirm = type === "confirm";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex justify-center items-center p-4">
      <div className="bg-gray-800 rounded-lg shadow-xl w-full max-w-md transform transition-all">
        <div className="p-6">
          <div className="flex items-start">
            <div className="mr-4 flex-shrink-0">{icons[type]}</div>
            <div className="flex-1">
              <h3
                className="text-lg leading-6 font-medium text-white"
                id="modal-title"
              >
                {title}
              </h3>
              <div className="mt-2">
                <p className="text-sm text-gray-300">{message}</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-1 rounded-full text-gray-400 hover:bg-gray-700 hover:text-white transition-colors"
              aria-label="Fechar"
            >
              <X size={20} />
            </button>
          </div>
        </div>
        <div className="bg-gray-700/50 px-6 py-4 flex flex-row-reverse gap-3">
          {isConfirm ? (
            <>
              <button
                type="button"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 sm:w-auto sm:text-sm"
                onClick={onConfirm}
              >
                Confirmar
              </button>
              <button
                type="button"
                className="w-full inline-flex justify-center rounded-md border border-gray-500 shadow-sm px-4 py-2 bg-gray-800 text-base font-medium text-white hover:bg-gray-700 sm:w-auto sm:text-sm"
                onClick={onClose}
              >
                Cancelar
              </button>
            </>
          ) : (
            <button
              type="button"
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-teal-600 text-base font-medium text-white hover:bg-teal-700 sm:w-auto sm:text-sm"
              onClick={onClose}
            >
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
